export default __webpack_public_path__ + "static/media/SIPO LOGO.c4fb04f0.png";